




import {Vue, Component} from 'vue-property-decorator'

import AboutBoccoChannel from '@/components/AboutBoccoChannel.vue'

@Component({
  components: {
    AboutBoccoChannel
  }
})
export default class AboutBoccoChannelView extends Vue {

}
